import type { ElementType } from 'react';
import { LifeRebuildScoreResultPage } from '@timeblock/assessment-content/assessments/life-rebuild-score/result-page';
import { PersonalizedGoalPlanResultPage } from '@timeblock/assessment-content/assessments/personalized-goal-plan/result-page';
import { ProblemFinderResultPage } from '@timeblock/assessment-content/assessments/problem-finder/result-page';

export const customResultPages = {
  'life-rebuild-score': LifeRebuildScoreResultPage,
  'personalized-goal-plan': PersonalizedGoalPlanResultPage,
  'problem-finder': ProblemFinderResultPage,
} satisfies Record<string, ElementType>;

export function getCustomResultPage(assessmentType: string): ElementType | undefined {
  return customResultPages[assessmentType as keyof typeof customResultPages];
}
